export const useSelectedCars = () => {
  const cars = useState<number[]>("selected-cars:cars", () => []);
  const popupOpen = useState<boolean>("selected-cars:popupOpen", () => false);
  const carsData = useState<any[]>("selected-cars:carsData", () => []);
  const isLoading = useState<boolean>("selected-cars:isLoading", () => false);

  const client = useClient();

  const nuxtApp = useNuxtApp() as {
    _selectedCarsLoadPromise?: Promise<void>;
    _selectedCarsDebouncedUpdateList?: (value: number[]) => void;
  };

  const loadCarsFromLocalStorage = () => {
    if (nuxtApp._selectedCarsLoadPromise) return nuxtApp._selectedCarsLoadPromise;

    isLoading.value = true;
    nuxtApp._selectedCarsLoadPromise = (async () => {
      try {
        const loaded = await client.car.loadSelectedCars.query();
        cars.value = loaded
      } catch (e) {
        console.error(e);
        cars.value = [];
      } finally {
        isLoading.value = false;
      }
    })();

    return nuxtApp._selectedCarsLoadPromise;
  }

  const updateList = async (value) => {
    if (!value) return;
    if (value.length === 0) {
      carsData.value = [];
      return;
    }

    const result = await client.car.list.query({filters: {ids: value}});
    carsData.value = result.items;
  }

  if (!nuxtApp._selectedCarsDebouncedUpdateList) {
    nuxtApp._selectedCarsDebouncedUpdateList = useDebounceFn(updateList, 3000);
  }

  const debouncedUpdateList = nuxtApp._selectedCarsDebouncedUpdateList;

  const isCarSelected = (carId) => {
    if (!cars.value) return false;
    if (cars.value.length === 0) return false;
    if (!carId) return false;
    if (!Array.isArray(cars.value)) return false;
    return cars.value.includes(carId);
  }

  const addCar = async (carId: number) => {
    if (isCarSelected(carId)) return;

    client.car.addSelectedCars.mutate({carId});

    cars.value.push(carId);
  }
  const removeCar = async (carId) => {
    if (!isCarSelected(carId)) return;

    client.car.removeSelectedCars.mutate({carId});

    cars.value.splice(cars.value.indexOf(carId), 1);
  }

  const toggleCarSelection = async (carId) => {
    if (isCarSelected(carId)) {
      await removeCar(carId);
    } else {
      await addCar(carId);
    }
    debouncedUpdateList(cars.value);
  }

  const runAction = async (action) => {
    switch (action) {
      case "invoice": {
        const {open} = await useRequestServiceModal({code: "BATCH_INVOICE", ids: cars.value});
        await open();
        break;
      }
    }
  }
  const clearCars = () => {
    popupOpen.value = false;
    client.car.clearSelectedCars.mutate({});

    cars.value = [];
  }

  const loadingItemProxy = new Proxy({}, {
    get: function (target, prop, receiver) {
      return "Loading car..."
    }
  })

  const list = computed(() => {
    return cars.value.map((carId) => {
      return carsData.value.find((car) => car.id === carId) || loadingItemProxy;
    })
  })

  watch(cars, debouncedUpdateList, {immediate: false});

  loadCarsFromLocalStorage();


  return reactive({
    cars,
    carsData,
    list,
    popupOpen,
    isLoading,
    addCar,
    removeCar,
    runAction,
    isCarSelected,
    toggleCarSelection,
    clearCars,
  });
}
